export enum ComplexityLevel {
  Simple = 0,
  Medium = 1,
  Complex = 2
}
